<template>
    <CCard>
        <CCardBody>


            <CCardHeader>
                <CRow>
                    <CCol col="8" style="text-align: start">

                        <strong>{{$t('newDocumentDoc')}}</strong>

                    </CCol>
                    <CCol col="4" style="text-align: end">
<!--                        Add normal doc-->
                        <CButton v-if="status_form==0  && selected_doc_type!=10 && selected_doc_type!=9 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_cash()" type="submit"
                                 size="sm" color="secondary">
                            {{ $t('buttons.submit') }}
                        </CButton>
                        <CButton v-if="status_form==0 && selected_doc_type!=10 && selected_doc_type!=9 && is_year_closed()" class="mr-1 ml-1"
                                 @click="year_closed_dialog()" type="submit"
                                 size="sm" color="danger">
                            {{ $t('buttons.submit') }}
                        </CButton>

<!--                        Add closing doc-->
                        <CButton v-if="status_form==0 && selected_doc_type==10 && !is_year_closed()" class="mr-1 ml-1"
                                 @click="close_year_dialog = true" type="submit"
                                 size="sm" color="secondary">
                            {{ $t('closeBalance') }}
                        </CButton>
                        <CButton v-if="status_form==0 && selected_doc_type==10 && is_year_closed()" class="mr-1 ml-1"
                                 @click="year_closed_dialog()" type="submit"
                                 size="sm" color="danger">
                            {{ $t('closeBalance') }}
                        </CButton>
<!--                        Add Opening Doc-->
                        <CButton v-if="status_form==0 && selected_doc_type==9 && !is_year_closed() && !is_year_opened()" class="mr-1 ml-1"
                                 @click="open_year_dialog = true" type="submit"
                                 size="sm" color="secondary">
                            {{ $t('openBalance') }}
                        </CButton>
                        <CButton v-if="status_form==0 && selected_doc_type==9 && is_year_closed() && is_year_opened()" class="mr-1 ml-1"
                                 @click="year_opened_dialog()" type="submit"
                                 size="sm" color="danger">
                            {{ $t('openBalance') }}
                        </CButton>
<!--                        Edit Doc-->
                        <CButton v-if="status_form!=0" @click="insert_data_cash()" type="submit" size="sm"
                                 color="secondary">
                            <CIcon name="cil-check-circle"/>
                            {{ $t('buttons.editDoc') }}
                        </CButton>
                        <CButton
                                class="mr-1"
                                size="sm"
                                color="secondary"
                        >{{ $t("buttons.print") }}
                        </CButton>
                        <a :href="$route.fullPath" target="_blank">
                            <CButton
                                    class="mr-1 ml-1"
                                    size="sm"
                                    color="dark"
                            >
                                <CIcon size="sm" name="cil-plus"></CIcon>
                            </CButton>
                        </a>
                    </CCol>
                </CRow>
                <!--        </div>-->

                <!-- Right aligned nav items -->
                <!--      </CCollapse>-->
            </CCardHeader>
            <CRow>
                <CCol col="3">
                    <div>
                        <CRow form class="form-group">
                            <CCol tag="label" sm="4" class="col-form-label">
                                {{$t('docDate')}}
                            </CCol>
                            <CCol sm="8">
                                <date-picker
                                        v-model="date"
                                        :min="get_min_doc_date()"
                                        :max="get_max_doc_date()"
                                ></date-picker>
                            </CCol>
                        </CRow>
                    </div>
                </CCol>
                <CCol col="3">

                    <CSelect
                            :label="$t('documentType')"

                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                            :options="child_types"
                            :value.sync="selected_doc_type"
                    />

                </CCol>

                <CCol col="3">
                    <treeselect
                            v-if="selected_doc_type==7 || selected_doc_type==8"
                            v-model="reference"
                            appendToBody
                            :async="true"
                            @search-change="add_master_to_search(item)"
                            :loadOptions="load_reference"

                            :placeholder="$t('searchReference')"
                            :normalizer="normalizer_refrence"
                    />
                </CCol>

                <CCol col="5">
                    <CInput
                            :label="$t('components.documentSummary')"
                            :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                            v-model="document_summary"
                            rows="1"
                    />
                </CCol>
            </CRow>
            <CRow>


                <CCol col="12">
                    <CDataTable
                        v-if="selected_doc_type!=10 && selected_doc_type!=9"
                            :items="items_pay_cash"
                            :fields="fields_pay_cash"
                            striped
                            border
                            style="height: 400px;overflow: auto"
                            :items-per-page="200"
                            hover
                            pagination
                    >
                        <template #row="{item,index}">

                            <td>
                                <label>{{ index + 1 }}</label>
                            </td>
                        </template>
                        <template #moein="{item,index}">
                            <td>
                                <treeselect
                                        v-model="item.moein"
                                        appendToBody
                                        :normalizer="normalizer_accounting"
                                        @select="select_moein(item,index,...arguments)"
                                        :cacheOptions="false"

                                        :options="moein_list"
                                        :placeholder="$t('components.search')"
                                />

                            </td>
                        </template>
                        <template #tafzili="{item,index}">
                            <td>
                                <treeselect
                                        v-model="item.tafzili"
                                        :appendToBody="true"
                                        @select="select_tafzili(index,item,...arguments)"
                                        :defaultOptions="item.tafzili_list"
                                        :cacheOptions="false"
                                        :load-options="load_tafsilies_async"
                                        :async="true"

                                        :placeholder="$t('components.search')"
                                        :normalizer="normalizer_accounting_tafzili"
                                />
                              <br>
                              <label
                                  v-if="item.remaining!=null && item.tafzili!=null"
                              >{{ $t('tables.balance') }} : {{ get_currency(item.remaining) }}</label>

                            </td>
                        </template>
                        <template #name="{item}">
                            <td>
                                <label
                                >{{ item.name }}</label>
                            </td>
                        </template>
                        <template #bedehkar="{item}">

                            <td>
                                <CInputCurrency
                                        :disabled="item.bestankar!='0'&& item.bestankar!=''&& item.bestankar!=null"
                                        v-model="item.bedehkar"
                                        @keypress="isDecimal2($event,item.bedehkar)"

                                />
                            </td>

                        </template>
                        <template #bestankar="{item,index}">
                            <td>
                                <CInputCurrency
                                        :disabled="item.bedehkar!='0'&& item.bedehkar!=''&& item.bedehkar!=null"
                                        @keypress="isDecimal2($event,item.bestankar)"

                                        v-model="item.bestankar"
                                />
                            </td>

                        </template>

                        <template #operation="{item,index}">
                            <td>
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        @click="items_pay_cash.splice(index+1, 0, {});"
                                        color="dark"
                                >
                                    <CIcon size="sm" name="cil-plus"></CIcon>
                                </CButton>
                                <CButton v-if="items_pay_cash.length>1"
                                         class="mr-1"
                                         size="sm"
                                         @click="items_pay_cash.splice(index,1),update_select_disable"
                                         color="primary"
                                >
                                    <CIcon size="sm" name="cil-minus"></CIcon>
                                </CButton>
                            </td>

                        </template>
                        <template #caption>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td v-if="bedehkar_total==bestankar_total" style="text-align: right">{{
                                get_currency(bedehkar_total) }}
                            </td>
                            <td v-if="bedehkar_total==bestankar_total" style="text-align: right">{{
                                get_currency(bestankar_total) }}
                            </td>
                            <td v-if="bedehkar_total!=bestankar_total" style="text-align: right" class="bg-danger">{{
                                get_currency(bedehkar_total) }}
                            </td>
                            <td v-if="bedehkar_total!=bestankar_total" style="text-align: right" class="bg-danger">{{
                                get_currency(bestankar_total) }}
                            </td>
                            <td>
                              {{Math.abs(bedehkar_total-bestankar_total)}}
                            </td>

                        </template>

                    </CDataTable>

                </CCol>


            </CRow>


        </CCardBody>
      <CModal
          :show.sync="close_year_dialog"
          :no-close-on-backdrop="true"
          :centered="true"
          size="sm"
          color="dark"
      >
        <td >{{$t('closeBalanceDialog')}}</td>
        <CRow form class="form-group">
          <CCol tag="label" sm="4" class="col-form-label">
            {{$t('docDate')}}
          </CCol>
          <CCol sm="8">
            <date-picker
                v-model="close_year_date"
                :min="get_min_doc_date()"
                :max="get_max_doc_date()"
            ></date-picker>
          </CCol>
        </CRow>
        <template #header>
          <h6 class="modal-title"></h6>
          <CButtonClose @click="close_year_dialog = false" class="text-white"/>
        </template>
        <template #footer>
          <CButton @click="close_year()"
                   color="danger"
          >{{$t("buttons.ok")}}
          </CButton>
          <CButton
              @click="close_year_dialog = false"
              color="success"
          >{{$t("buttons.cancel")}}
          </CButton>
        </template>
      </CModal>
      <CModal
          :show.sync="open_year_dialog"
          :no-close-on-backdrop="true"
          :centered="true"
          size="sm"
          color="dark"
      >
        <td >{{$t('openBalanceDialog')}}</td>
        <CRow form class="form-group">
          <CCol tag="label" sm="4" class="col-form-label">
            {{$t('fromYear')}}
          </CCol>
            <CCol sm="8">
                <CSelect
                        :options="years_list.filter(x=>x.closed==1)"
                        :value.sync="last_close_year_date"

                ></CSelect>
            </CCol>
        </CRow>
          <CRow form class="form-group">
          <CCol tag="label" sm="4" class="col-form-label">
            {{$t('docDate')}}
          </CCol>
          <CCol sm="8">
            <date-picker
                v-model="open_year_date"
                :min="get_min_doc_date()"
                :max="get_max_doc_date()"
            ></date-picker>
          </CCol>
        </CRow>
        <template #header>
          <h6 class="modal-title"></h6>
          <CButtonClose @click="open_year_dialog = false" class="text-white"/>
        </template>
        <template #footer>
          <CButton @click="open_year()"
                   color="danger"
          >{{$t("buttons.ok")}}
          </CButton>
          <CButton
              @click="open_year_dialog = false"
              color="success"
          >{{$t("buttons.cancel")}}
          </CButton>
        </template>
      </CModal>

    </CCard>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import BTabs from "../../tabs/BTabs";
    import CInputNumber from "@/views/panel/includes/CInputNumber";
    import Vue from 'vue';
import  closeBalance from "@/functions/closingBalance";
import openBalance from "@/functions/openingBalance";
    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    export default {
        name: 'Login',
        components: {
            Treeselect,
            BTabs,
            CInputNumber,
        },

        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                reference: null,
                master_id: null,
                master_types: [{id: '1', label: this.$t('factor')}, {id: '2', label: this.$t('debtors')}, {
                    id: '3',
                    label: this.$t('persons')
                }],
              async_tafzili:false,
                active_tab: 0,
                close_year_dialog:false,
                open_year_dialog:false,
                date_cash: '',
                date_cheque: '',
                summary: '',
                cashiers: [],
                banks: [],
                child_types: [],

                terminals: [],
                selected_payer: 0,
                selected_receiver_cash: null,
                selected_receiver_cheque: null,

                status_form: 0,
                price: '',
                date: '',
              close_year_date: '',
              open_year_date: '',
              years_list: [],
                last_close_year_date:0,
                document_summary: '',
                items_accounting_groups: [],
                selected_accounting_group: null,
                items_accounting_sub_groups: [],
                selected_accounting_sub_group: null,
                items_accounting_data: [],

                fields_pay_cash: [
                    {key: 'row', label: "No.", _style: 'width:2%;padding:0px'},
                    {key: 'moein', label: this.$t('accountSarfasl'), _style: 'width:15%;padding:0px'},

                    {key: 'tafzili', label: this.$t('tafsiliAccount'), _style: 'width:10%;padding:0px'},

                    {key: 'bedehkar', label: this.$t('bedehkar'), _style: 'width:7%;padding:0px'},
                    {key: 'bestankar', label: this.$t('bestankar'), _style: 'width:7%;padding:0px'},
                    {key: 'operation', label: "", _style: 'width:5%;padding:0px'},

                ],
                items_pay_cash: [{}],
                doc_types: [],
                selected_doc_type: 0,
                accounting_list: [],
                moein_list: [],
                current_year_id:0,
                searched_person: [],
                document_person: null,
                document_person_cheque: null,
                search_user_async: true,
              selected_node_moein:0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
                normalizer_accounting(node) {
                    return {
                        id: node.id,
                        label: node.accountCode + " " + node.accountName,
                    }
                },

                normalizer_documents(node) {
                    return {
                        id: node.id,
                        label: node.label,
                    }
                },

                normalizer_refrence(node) {
                    return {
                        id: node.factorMasterId,
                        label: node.factorMasterId,
                    }
                },

                items_pre_cheque: [{}],
                get_items: [1],
                cheque_banks: [],
            }
        },
      mounted() {
          // this.$root.modal_component.show_danger_modal(this.$t("dialogs.error"), this.$t('year_is_opened_dialog'));

          // this.year_closed_dialog(this.$root.modal_component);
            this.date_cash = this.get_today();
            this.date = this.get_today();
            this.close_year_date = this.get_max_doc_date();
            this.open_year_date = this.get_max_doc_date();
            this.date_cheque = this.get_today();

            // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
            this.get_years();
            this.get_banks();
            this.get_cashiers();
            this.get_terminals();
            this.get_lists_groups();
            this.get_sys();
            this.get_child_types()


            if (this.$route.params.product_id != null) {
                this.editable = true;
                this.status_form = this.$route.params.product_id;
                this.get_product_data();
            }
          bus.$on("update_add_docs", (data) => {
              // alert(data);
              this.selected_doc_type = this.doc_types[0].value

          });
        },
      watch: {
            'selected_doc_type': function () {
                // this.get_child_types()


                this.generate_summary()
            },
            'selected_accounting_group': function () {
                this.get_lists_sub_groups();
            },
            // 'selected_doc_child_type': function () {
            //     this.reference = null
            //     this.generate_summary()
            // },
            'reference': function () {
                this.generate_summary()
            }

        },
        computed: {
            bestankar_total() {
                var total = 0;
                this.items_pay_cash.forEach((val) => {
                    if (val.bestankar != null && val.bestankar != '') {
                        total += parseFloat(val.bestankar.replace(/,/g, ''));
                    }
                });
                return total;
            },
            bedehkar_total() {
                var total = 0;
                this.items_pay_cash.forEach((val) => {
                    if (val.bedehkar != null && val.bedehkar != '') {
                        total += parseFloat(val.bedehkar.replace(/,/g, ''));

                    }
                });
                return total;
            },

            payer_items() {
                var items = [];
                if (this.selected_doc_type == 2) {
                    this.cashiers.forEach((val) => {
                        var obj = {label: val.boxTitle, value: val.id}
                        items.push(obj)
                    });
                }
                if (this.selected_doc_type == 6) {
                    this.banks.forEach((val) => {
                        var obj = {label: val.bankAccTitle, value: val.id}
                        items.push(obj)
                    });
                }
                if (this.selected_doc_type == 1) {
                    this.terminals.forEach((val) => {
                        var obj = {label: val.terminalTitle, value: val.id}
                        items.push(obj)
                    });
                }
                if (items.length > 0) {
                    this.selected_payer = items[0].value;
                }
                return items;
            },

            payfor_items() {
                var items = [];

                return items;
            },
        },
        methods: {
            get_years() {
                var self = this;

                const formData = new FormData();
                // formData.append('id', this.selected_province);
                axios.post('GetFiscalYears', formData, {}).then(function (response) {
                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.years_list = self.sort_array([],content_data.data,"id","title");

                        if(self.years_list.filter(x=>x.closed==1).length>0){
                            self.last_close_year_date = self.years_list.filter(x=>x.closed==1)[self.years_list.filter(x=>x.closed==1).length-1].id
                        }
                        self.current_year_id = content_data.data.filter(x=>x.isActive==1)[0].id
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

          close_year(){
            this.close_year_dialog = false
              var self = this
              setTimeout(function () {
                  closeBalance.get_lists_moeins(self.close_year_date,self.current_year_id)

              }, 500);

          },
          open_year(){
            this.open_year_dialog = false


               var self = this
              setTimeout(function () {
                  var last_year_date = self.years_list.filter(x=>x.id==self.last_close_year_date)[0].endDate
                  openBalance.get_lists(self.open_year_date,self.current_year_id,self.last_close_year_date,last_year_date)

              }, 500);

          },
            normalizer_accounting_tafzili(node) {
                return {
                    id: node.recId,
                    label: node.recTitle,
                    isDisabled: this.check_disabled(node),
                }
            },
            check_disabled(node) {
                var disabled = false;
                this.items_pay_cash.forEach(function (val) {

                    if (val.tafzili == node.recId && val.moein == node.accountId) {
                        disabled = true;
                        console.log("node is disabled ", node, val)

                    }
                })

                return disabled;

            },
            load_reference({action, searchQuery, callback}) {
                var self = this
                console.log(self.search_reference_master)
                if (action === ASYNC_SEARCH) {
                    simulateAsyncOperation(() => {
                        let options;
                        const formData = new FormData();

                        formData.append('Id', self.selected_doc_type);
                        formData.append('SearchTxt', searchQuery);

                        axios.post('GetAccountDocList', formData, {show_pros: true}).then(function (response) {
                            options = response.data.data;

                            callback(null, options);

                            // localStorage.setItem("api_token", response.data.access_token);
                            // self.$router.push({ path: 'notes' });
                        })
                            .catch(function (error) {
                                console.log(error);
                            });
                    })
                }
            },

            generate_summary() {
                if (this.selected_doc_type != 0) {
                    this.document_summary = this.child_types.filter(x => x.value == this.selected_doc_type)[0].label
                    // this.document_summary += " "+this.child_types.filter(x =>x.value == this.selected_doc_child_type)[0].label
                    if (this.reference != null) {
                        this.document_summary += " " + this.reference

                    }
                }

            },
            get_sys() {
                var self = this;

                const formData = new FormData();

                axios.post('Get_Sys_MainAccDocType', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.doc_types = [];

                    self.doc_types = self.sort_array(self.doc_types, content_data.data, "accTypeId", "accTypeTitle")

                    // self.doc_types.sort((a, b) => a.title.localeCompare(b.title, undefined, {numeric: true, sensitivity: 'base'}));

                    self.doc_types.sort(function (a, b) {
                        return a.orderNo - b.orderNo;
                    });
                    self.selected_doc_type = self.doc_types[0].value
                    self.get_child_types()
                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            select_tafzili(index,item, node) {
                item.name = node.title;

              this.update_select_disable();
              this.get_person_remaining_amount(index,item,node)
            },
          get_person_remaining_amount(index2, item,e) {
              console.log("e,",item,e)
            var self = this;
            const formData = new FormData();

            formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
            formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
            var url = ""
            if ([80, 91, 92, 163].includes(item.moein)) {
              url = "GetLastPartyAccountByParam"

            } else {
              url = "GetPersonAccountsByPersonId_New"
            }
            if (item.moein == 80) {//customers
              formData.append('TafsiliType', 2);
            } else if (item.moein == 163) {//suppliers
              formData.append('TafsiliType', 3);
            } else if (item.moein == 70|| item.moein== 73) {
              formData.append('TafsiliType', 6);
            } else if (item.moein == 288) {
              formData.append('TafsiliType', 7);
            } else {
              formData.append('TafsiliType', 5);
            }

            formData.append('id', 0);


            formData.append('PartyId', e.recId);
            formData.append('ParentId', 10);
            formData.append('ChildId', 10);
            axios.post(url, formData, {}).then(function (response) {

              var content_data = response.data;

              // items = content_cats.orders;
              if (content_data.statusCode == 0) {
                if ([80, 91, 92, 163].includes(item.moein)) {
                  Vue.set(self.items_pay_cash[index2], "remaining", response.data.data.balance);
                  console.log("self.items_pay_cash[index]",self.items_pay_cash[index2])

                } else {
                  var items1 = content_data.data.personAccountItems.map((item, row_id) => {
                    return {...item, row_id}
                  });
                  items1.forEach(function (val, index) {
                    if (index == 0) {
                      val.reminingBefore = 0;
                      if (val.natureId == 0 && items1[index + 1] != null) {
                        val.natureId = items1[index + 1].natureId;
                      }
                      // val.accBalance = val.accBalance
                    } else {
                      val.reminingBefore = items1[index - 1].accBalance;

                      if (val.natureId == 2) {
                        val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                        // val.accBalanceFinal =val.accBalance
                        if (val.amount > 0) {
                          val.amountNegetive = Math.abs(val.amount);
                          val.amount = 0;

                        } else {
                          val.amount = Math.abs(val.amount);
                          val.amountNegetive = 0;
                        }
                      } else {

                        val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                        if (val.amount < 0) {
                          val.amountNegetive = 0;
                          val.amount = Math.abs(val.amount);

                        } else {
                          val.amountNegetive = Math.abs(val.amount);
                          val.amount = 0;

                        }
                      }
                    }

                    Vue.set(self.items_pay_cash[index2], "remaining", items1[items1.length - 1].accBalance * -1);
                    console.log("self.items_pay_cash[index]",self.items_pay_cash[index])
                    // item.remaining

                  })

                }

                // response.data.data.balance
              } else {
                self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

              }
            })
                .catch(function (error) {

                  console.log(error);
                });

          },

          update_select_disable() {
                setTimeout(() => {
                    this.items_pay_cash.forEach(function (val) {
                        // if (val_index != index) {
                        var tmp_taf = JSON.parse(JSON.stringify(val.tafzili_list));
                        val.tafzili_list = [];
                        val.tafzili_list = JSON.parse(JSON.stringify(tmp_taf))
                        // }

                    })
                }, 300);

            },
            select_moein(item, index, node) {
                var self = this;
                item.tafzili_list = []
              self.async_tafzili=false
                const formData = new FormData();
                var url = "GetAccTafsilisByAccountId";
                Vue.set(self.items_pay_cash[index],'tafzili',null)

                this.selected_node_moein = {node:node.id,index:index}
                formData.append("accId", node.id);

                // self.tafzili_list = [];

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {
                            response.data.data.forEach(function (val) {
                                val.accountId = node.id
                            })
                            // item.tafzili_list = response.data.data;
                            Vue.set(self.items_pay_cash[index], "tafzili_list", response.data.data)
                        setTimeout(function (){
                          self.async_tafzili=true

                        },500)
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                ).catch(function (error) {
                    console.log(error);
                });

            },
          load_tafsilies_async({action, searchQuery, callback}) {
var self = this
            if (action === ASYNC_SEARCH) {
              simulateAsyncOperation(() => {
                let options;
                const formData = new FormData();

                formData.append('GetAccTafsilisByAccountId', searchQuery);
                formData.append('SearchTxt', searchQuery);
                formData.append("accId", self.selected_node_moein.node);


                axios.post('GetAccTafsilisByAccountId', formData, {show_pros: false}).then(function (response) {
                  response.data.data.forEach(function (val) {
                    val.accountId = self.selected_node_moein.node
                  })
                  options = response.data.data;

                  callback(null, options);

                  // localStorage.setItem("api_token", response.data.access_token);
                  // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {
                      console.log(error);
                    });
              })
            }
          },
          load_tafsilies(item, index, node) {
                var self = this;
              self.async_tafzili=false
                const formData = new FormData();
                var url = "GetAccTafsilisByAccountId";
                formData.append("accId", node.id);

                // self.tafzili_list = [];

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {
                            response.data.data.forEach(function (val) {
                                val.accountId = node.id
                            })
                            // item.tafzili_list = response.data.data;
                            Vue.set(self.items_pay_cash[index], "tafzili_list", response.data.data)
                        setTimeout(function (){
                          self.async_tafzili=true

                        },500)
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                ).catch(function (error) {
                    console.log(error);
                });

            },
            get_child_types() {

                var self = this;
                self.child_types = [];

                const formData = new FormData();
                var url = "Get_Sys_AccDocType";
                formData.append("Id", this.selected_doc_type);
                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {


                            self.child_types = self.sort_array([], response.data.data, 'accTypeId', 'accTypeTitle');
                            self.child_types.sort(function (a, b) {
                                return a.orderNo - b.orderNo;
                            });

                            // self.child_types_filter = self.sort_array([],response.data.data ,'accTypeId','accTypeTitle');
                            // self.selected_doc_type = self.doc_types[0].value
                            // self.child_types_filter = self.child_types.filter(x=>x.parentId==self.selected_doc_type);
                            if (self.child_types.length > 0) {
                                // self.selected_doc_child_type = self.child_types[0].value;
                                self.selected_doc_type = self.child_types[0].value;
                            }
                            console.log("child types is", self.child_types)
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_groups() {

                var self = this;
                self.items_parent = [];
                self.data_with_children = []

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            self.accounting_list = response.data.data
                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                                        self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                                            self.moein_list.push(val3)

                                        });

                                    });

                                }

                            });
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens(parent_id, list) {
                var array = [];
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        var obj = {
                            name: val2.accountName,
                            name_code: val2.accountName + " (" + val2.accountCode + ")",
                            code: val2.accountCode,
                            id: val2.id,
                            children: this.get_childrens(val2.id, list),
                            nature: val2.nature,
                            type: val2.type,
                            parentId: val2.parentId,
                        }
                        array.push(obj);
                        // val2.inserted = true;

                    }
                });
                return array;
            },
            get_childrens_row(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountName,  value: val2.id}
                        array.push(val2);
                        self.get_childrens_row(val2.id, list).forEach((val3) => {

                            // var obj = {label: val3.accountName,  value: val3.id}
                            array.push(val3);
                            // val2.inserted = true;
                        });

                    }
                });
                return array;
            },
            get_childrens_one_sub(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
                        array.push(val2);


                    }
                });
                return array;
            },
            add_master_to_search(item) {
                console.log("search item search");
                this.search_reference_master = item.document_person
            },
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.document_person != null && this.price != '') {
                    return true;
                }

                if (this.document_person == null) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.selectUser'));
                }
                if (this.price == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertAmount'));
                }

                return false;
                // e.preventDefault();
            },

            insert_data_cash() {
                // if (!this.validateFormCash()) {
                //   console.log("validate form is false" + this.validate_errors);
                //   return true;
                // }

                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddAccountDoc";
                } else {
                    url = "AddAccountDoc";
                    formData.append('id', this.status_form)

                }

                // AddAccountDoc

                // AddAccountDocFinal => Id pas midi

                // date
                // selected_doc_type
                // document_summary
                // items_pay_cash

                var details = [];
                var validate = true;
                for (var i = 0; i < this.items_pay_cash.length; i++) {
                    var obj = {
                        DocType: this.selected_doc_type,
                        DocName: this.selected_doc_child_type,
                        ReferenceId: this.reference,
                        DocDate: this.date,
                        Summary: this.document_summary,
                        AccountId: this.items_pay_cash[i].moein,
                        TafsiliId: this.items_pay_cash[i].tafzili,
                        TafsiliTitle: this.items_pay_cash[i].name,

                    };
                    if(this.items_pay_cash[i].bedehkar!='' && this.items_pay_cash[i].bedehkar!=null && this.items_pay_cash[i].bedehkar!=0){
                      obj.Debtor = this.items_pay_cash[i].bedehkar
                    }
                    if(this.items_pay_cash[i].bestankar!='' && this.items_pay_cash[i].bestankar!=null && this.items_pay_cash[i].bestankar!=0){
                      obj.Creditor = this.items_pay_cash[i].bestankar
                    }
                    if (obj.ReferenceId == null) {
                        obj.ReferenceId = 0;
                    }
                    if (obj.TafsiliId == null || obj.TafsiliId == 0 || obj.TafsiliId == '') {
                        validate = false;
                    }
                    if ((obj.Debtor == null || obj.Debtor == 0 || obj.Debtor == '') && (obj.Creditor == null || obj.Creditor == 0 || obj.Creditor == '')) {
                        validate = false;
                    }
                  console.log("validate",obj)

                    details.push(obj)
                }
                if (validate == false) {
                    this.$root.modal_component.show_validate_errors([this.$t('fillAllFields')])
                    return false;
                }
                formData.append('input', JSON.stringify(details));

                axios.post(url, formData, {}).then((res) => {
                    //

                    self.$root.modal_component.show_api_response_modals(res);

                    // self.get_lists();
                    if (res.data.statusCode == 0) {

                        bus.$emit("update_add_docs", "");
                        self.$router.push({path: "/dashboard/accounting/show-accounting-doc/" + res.data.data.id})

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_banks() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetBankAccounts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.banks = content_data.data;

                        self.banks.forEach((val) => {
                            var obj = {label: val.bankAccTitle, value: val.id}
                            self.cheque_banks.push(obj)
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cashiers() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);

                axios.post('GetCashierTitles', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.cashiers = content_data.data;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_terminals() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetBankTerminals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.terminals = content_data.data;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        }
    }

</script>
